<template>
  <div style="width: 100%;">
    <div class="d-flex justify-space-between">
    <v-text-field
      clearable
      outlined
      class="mx-2"
      dense
      v-model="searchTerms"
      label="Search"
      @keyup.enter="search"
      @click:clear="clearSearch"
      @click:append="search"
      append-icon="mdi-magnify"
    />
      <v-btn color="primary" target="_blank" :href="newFormLink">Create New Form</v-btn>
    </div>
    <infinite-scroll
      :key="infiniteScrollKey"
      @fetchData="fetchData"
      :totalPages.sync="totalPages"
    >
      <v-row ref="formlist" dense>
        <v-col cols="12">
          <div class="text-subtitle-2 ml-2 text-center font-weight-light">
            {{ forms.length }} Forms found
          </div>
        </v-col>
        <v-col v-for="form in forms" :key="form.id" cols="12" lg="4" md="6">
          <v-hover v-slot="{ hover }">
            <v-card
              @click="selectForm(form)"
              ripple
              :elevation="hover ? 5 : 2"
              class="ma-0 ma-md-1 ma-lg-2"
              min-height="225px"
            >
              <v-card-title>
                <div>
                  {{ form.name }}
                  <span v-if="form.formType === 'COVID19'">(COVID-19)</span>
                </div>
              </v-card-title>
              <v-card-subtitle>
                For {{ form.contactType }} @
                {{ getCenterName(form.centerId) }}
              </v-card-subtitle>
              <v-card-text>
                <div style="height: 100px; overflow: scroll">
                  <span v-html="form.description"></span>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <div class="text-caption">
                  v.{{ form.version ? form.version : "1.0" }}
                </div>
              </v-card-actions>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </infinite-scroll>

  </div>
</template>

<script>
import { parseDomain } from "parse-domain";

import { mapGetters, mapActions } from "vuex";
export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    forms: [],
    searchTerms: "",
    infiniteScrollKey: Date.now(),
    totalPages: null,
    totalSizes: null,
  }),
  computed: {
    ...mapGetters("auth", ["myCenters"]),
    newFormLink(){
      if (process.env.NODE_ENV != "development") {
          const parseResult = parseDomain(window.location.hostname);
          const { domain, topLevelDomains } = parseResult;
          const topLevel = topLevelDomains.join(".");

          return `https://form-admin.${domain}.${topLevel}/#/form`;
        } else {
          return `http://localhost:8085/#/form`;
        }
    }
  },
  methods: {
    ...mapActions("messages", ["addErrorMessage", "addSuccessMessage", "clearMessage"]),
    search() {
      this.infiniteScrollKey = Date.now();
    },
    clearSearch() {
      this.searchTerms = null;
      this.infiniteScrollKey = Date.now();
    },
    fetchData({ page, done, empty }) {
      const data = {
        page,
        size: 5,
        sortInfos: [
          {
            sortCol: "createdAt",
            sortDir: "desc",
          },
        ],
        search_terms: this.searchTerms,
      };
      this.$axios
        .post("/form/get-forms", data)
        .then((resp) => {
          this.forms = resp.data.content;
          this.totalPages = resp.totalPages;
          this.totalSizes = resp.totalElements;
          if (this.totalSizes > 0) {
            done();
          } else {
            empty();
          }
        })
        .catch((error) => {
          this.addErrorMessage(error.message || "Error retrieving form data");
        });
    },
    getCenterName(centerId) {
      if (centerId && this.myCenters && this.myCenters.length > 0) {
        const center = this.myCenters.find((c) => c.id == centerId);
        if (center && center.name) {
          return center.name;
        } else {
          return "N/A";
        }
      } else {
        return "N/A";
      }
    },
    selectForm(form) {
      this.$emit("input", form);
      this.$emit("selected", form);
    },
  },
};
</script>

<style>
</style>